export const Switch = ({
	active = false,
	onClick,
}: {
	active: boolean,
	onClick?: () => void;
}) => {
	return (
		<div
			className="switch"
			onClick={onClick}
			data-active={active}
		>
			<div className="switch__thumb"></div>
		</div>
	)
}